import { defineStore } from 'pinia'
import api from '@/services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null,
    user: null,
  }),
  actions: {
    async login (email, password) {
      const { data } = await api.post('/auth/login', { email, password })
      this.token = data.token
      this.user = data.user
      localStorage.setItem('token', this.token)
      // Opcional: también ponlo en axios por si no usas el interceptor en algún lado
      api.defaults.headers.common.Authorization = `Bearer ${this.token}`
    },
    logout () {
      this.token = null
      this.user = null
      localStorage.removeItem('token')
      delete api.defaults.headers.common.Authorization
    },
    async restoreFromStorage () {
      const token = localStorage.getItem('token')
      if (token) {
        this.token = token
        api.defaults.headers.common.Authorization = `Bearer ${token}`
        // (opcional) podrías pedir /me si tu backend lo expone
      }
    }
  }
})
